module.exports = __webpack_public_path__ + "img/Realisme_Andre_kunstformer_Arkitektur.ce21a85c.jpg";